import React, { PropsWithChildren } from 'react';
import bem from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';

export enum BadgeModifier {
  CONTENT = 'badge--content',
  CONTENT_ACTIVE = 'badge--content-active',
  ALERT = 'badge--alert',
  STATUS = 'badge--status',
  HIGHLIGHT = 'badge--highlight',
  INACTIVE = 'badge--inactive',
  SMALL_FONT = 'badge--small-font',
  PADDING_TOP_1 = 'badge--padding-top-1',
  DARK = 'badge--dark',
  NO_HELP_CURSOR = 'badge--no-help-cursor',
  SMALL = 'badge--small',
}

type BadgeProps = PropsWithChildren<{
  title?: string;
  modifier?: Modifier<BadgeModifier>;
}>;

/**
 * Badge Component
 */
export function Badge({ title, modifier, children }: BadgeProps) {
  return (
    <span className={bem('badge', modifier)} title={title}>
      {children}
    </span>
  );
}
